import {
  Factory,
  type ID,
  ProjectActions,
} from '@octopus-do/octopus-project-core'

import { getId } from '@/utils/temporaryHelper'

// @todo review - move this to store folder to keep all actions/action creators in one place
export const getNewTabActions = (tabId: ID, colorId: ID) => {
  const sectionId = getId()
  const nodeId = getId()

  return [
    ProjectActions.tabs.add({
      index: -1,
      items: [Factory.tab({ id: tabId })],
      parents: [],
    }),
    ProjectActions.sections.add({
      items: [
        Factory.section({
          id: sectionId,
          title: 'MAIN',
          tabId,
          colorId,
        }),
      ],
      index: 0,
      parents: [tabId],
    }),
    ProjectActions.nodes.add({
      items: [Factory.node({ id: nodeId, colorId })],
      index: 0,
      parents: [sectionId],
    }),
  ]
}
